import { Component, ViewChild } from "@angular/core";
import { AppRoutes } from "src/app/constants";
import { IonSlides } from "@ionic/angular";

@Component({
  selector: "app-report",
  templateUrl: "./report.page.html",
  styleUrls: ["./report.page.scss"],
})
export class ReportPage {
  @ViewChild("mySlider", { static: true }) public slider: IonSlides;

  public routes: typeof AppRoutes = AppRoutes;

  public ranking = [
    {
      rank: 1,
      name: "Sabine Tesla",
    },
    {
      rank: 2,
      name: "Marta Tesla",
    },
    {
      rank: 3,
      name: "Ricardo Tesla",
    },
    {
      rank: 4,
      name: "Estela Tesla",
    },
    {
      rank: 5,
      name: "Jaime Tesla",
    },
  ];

  constructor() {}

  public nextSlide(): void {
    if (this.slider) {
      this.slider.slideNext();
    }
  }

  public prevSlide(): void {
    if (this.slider) {
      this.slider.slidePrev();
    }
  }
}
